import { useCallback, useState } from "react";
import type { PinStep } from "web_myplann/Goals/Types/PinStep";

export const usePinStepStack = () => {
	const [steps, setSteps] = useState<PinStep[]>([]);

	const openStep = useCallback((step: PinStep) => {
		setSteps((current) =>
			current.includes(step) ? current : [...current, step],
		);
	}, []);

	const startAt = useCallback((step: PinStep) => {
		setSteps([step]);
	}, []);

	const closeStep = useCallback((step: PinStep) => {
		setSteps((current) => {
			const index = current.indexOf(step);
			return index < 0 ? current : current.slice(0, index);
		});
	}, []);

	const closeAll = useCallback(() => {
		setSteps([]);
	}, []);

	return { steps, openStep, startAt, closeStep, closeAll };
};
